import React from "react";
import PropTypes from "prop-types";

import { Alert, Button, Descriptions, Drawer, Space, Typography } from "antd";

import { AGREEMENT_STATUS_LABELS, formatAmount } from "../../../../../constants/marketplaceCheckout";
import useCurrency from "../../../../../hooks/useCurrency";

const { Text } = Typography;

/**
 * Validation de l'accord : l'acheteur relit les termes négociés puis passe
 * au parcours livraison + paiement (PaymentFinalizationDrawer).
 */
const FinalizeProductPurchaseDrawer = ({ open, agreement, currentUserId, onClose, onContinue }) => {
    const isBuyer = Boolean(currentUserId && agreement?.buyerId && String(agreement.buyerId) === String(currentUserId));
    const { currency: contextCurrency } = useCurrency();
    const currency = agreement?.currency || contextCurrency;

    return (
        <Drawer title="Validation de l'accord" placement="right" size={560} open={open} onClose={onClose} destroyOnClose>
            {agreement && (
                <Space orientation="vertical" size="large" style={{ width: "100%" }}>
                    <Descriptions column={1} bordered size="small">
                        <Descriptions.Item label="Quantité">
                            {agreement.agreedNumberOfPackets} paquet(s) de {agreement.agreedQuantityPerPacket} {agreement.measurementUnit || ""}
                        </Descriptions.Item>
                        <Descriptions.Item label="Prix par paquet">
                            {formatAmount(agreement.agreedUnitPricePerPacket, currency)}
                        </Descriptions.Item>
                        <Descriptions.Item label="Montant des produits">
                            <strong>{formatAmount(agreement.productAmount, currency)}</strong>
                        </Descriptions.Item>
                        {agreement.commercialTerms && (
                            <Descriptions.Item label="Conditions">{agreement.commercialTerms}</Descriptions.Item>
                        )}
                        <Descriptions.Item label="Statut">
                            {AGREEMENT_STATUS_LABELS[agreement.status]?.label || agreement.status}
                        </Descriptions.Item>
                    </Descriptions>

                    {isBuyer ? (
                        <>
                            <Text type="secondary">
                                Étape suivante : choix de la livraison, calcul des frais puis paiement.
                            </Text>
                            <Button type="primary" size="large" block onClick={() => onContinue?.(agreement)}>
                                Valider et passer à la livraison et au paiement
                            </Button>
                        </>
                    ) : (
                        <Alert
                            type="info"
                            showIcon
                            title="En attente de l'acheteur"
                            description="L'acheteur choisit la livraison et règle la commande."
                        />
                    )}
                </Space>
            )}
        </Drawer>
    );
};

FinalizeProductPurchaseDrawer.propTypes = {
    open: PropTypes.bool,
    agreement: PropTypes.shape({
        buyerId: PropTypes.string,
        status: PropTypes.string,
        currency: PropTypes.string,
        measurementUnit: PropTypes.string,
        commercialTerms: PropTypes.string,
        agreedNumberOfPackets: PropTypes.number,
        agreedQuantityPerPacket: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        agreedUnitPricePerPacket: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        productAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }),
    currentUserId: PropTypes.string,
    onClose: PropTypes.func,
    onContinue: PropTypes.func
};

export default FinalizeProductPurchaseDrawer;
